import React, {ReactElement} from 'react';
import {useHistory} from 'react-router';

type ContentContainerProps = {
  children: React.ReactNode;
};

const ContentContainer: React.FC<ContentContainerProps> = ({
  children,
}: ContentContainerProps): ReactElement => {
  const pathname = useHistory().location.pathname;

  const getContainerBottom = (): string => {
    if (!(pathname === '/home' || pathname === '/home/')) {
      return 'bottom-16';
    } else {
      return 'bottom-0';
    }
  };

  const getBgColor = (): string => {
    if (pathname === '/home/contact-us') {
      return 'bg-purple_1';
    } else {
      return '';
    }
  };

  const getContainerStyle = (): string => {
    if (pathname === '/home') {
      return '';
    } else {
      return 'content-container';
    }
  };

  return (
    // <div className={`absolute top-16 ${getContainerBottom()} overflow-y-scroll overflow-x-hidden left-0 right-0`}>
    //   {children}
    // </div>
    <div
      className={`${getContainerStyle()} ${getBgColor()} ${getContainerBottom()} overflow-y-scroll overflow-x-hidden left-0 right-0`}>
      {children}
    </div>
  );
};

export default ContentContainer;
